/**
 * 是否为数组属性
 *
 * @format
 * @param source
 * @param target
 */

export function isArrayProperty(source: any, target: any): undefined | boolean {
  if (Array.isArray(source) || Array.isArray(target)) {
    return target;
  }
}
